import { initials } from "@/lib/tp";

export function UserAvatar({ user, size = 28, ring = true }) {
  if (!user) return null;
  const bg = user.color || "#0A84FF";
  const px = size;
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold ${ring ? "ring-2 ring-black/40" : ""}`}
      style={{
        width: px,
        height: px,
        background: user.avatar_url ? undefined : bg,
        fontSize: Math.max(10, size / 2.6),
        backgroundImage: user.avatar_url ? `url(${user.avatar_url})` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      title={user.name}
    >
      {!user.avatar_url && initials(user.name)}
    </div>
  );
}

export function AvatarStack({ users = [], size = 26, max = 3 }) {
  const visible = users.slice(0, max);
  const overflow = users.length - visible.length;
  return (
    <div className="flex items-center -space-x-2">
      {visible.map((u) => (
        <UserAvatar key={u.id} user={u} size={size} />
      ))}
      {overflow > 0 && (
        <div
          className="inline-flex items-center justify-center rounded-full bg-zinc-800 text-zinc-200 ring-2 ring-black/40 text-xs font-semibold"
          style={{ width: size, height: size }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
